<template>
  <div class="serviceDetailWrapper">
    <!-- 患者档案 -->
    <div class="header">
      <PatientRecord :patient="patientInfo" />
    </div>
    <div class="scrollWrapper" ref="scrollWrapperRef" @scroll="updateShadow">
      <!-- 服务事项 -->
      <div class="serviceTips">
        <ServiceTips :data="serviceTipData" />
      </div>
      <!-- 服务进度 -->
      <div class="serviceProgress">
        <ServiceProgress
          :handleQuestion="handleQuestionJump"
          :parentInstanceSn="parentInstanceSn"
          :jumpAppPage="goAppPage"
          :userId="userId"
        />
      </div>
      <!-- 阴影吸附在底部 -->
      <div v-show="showShadow" class="timeline-shadow"></div>
    </div>
    <!-- 底部footer -->
    <div class="footerWrapper">
      <BottomCopy />
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, defineProps, onMounted, nextTick } from 'vue'
import PatientRecord from '../components/PatientRecord'
import { getPatientInfo, getServiceTipList } from '@/api/workPlace/serviceAttribution'
import ServiceTips from './components/ServiceTips'
import ServiceProgress from './components/ServiceProgress'
import BottomCopy from '../components/BottomCopy'

const props = defineProps({
  ucPatientId: {
    type: Number,
    default: null
  },
  parentInstanceSn: {
    type: String,
    default: ''
  },
  userId: {
    type: String,
    default: ''
  }
})
const scrollWrapperRef = ref()
// 展示底部阴影
const showShadow = ref(false)
// 服务患者信息
const patientInfo = reactive({})
// 服务事项数据
const serviceTipData = reactive({})
// 获取服务患者信息
const fetchPatientInfo = async () => {
  const { ucPatientId } = props
  const ucUserId = ucPatientId
  const result = await getPatientInfo(ucUserId)
  Object.assign(patientInfo, {
    ...result
  })
}
// 获取服务事项列表
const fetchServiceTipList = async () => {
  const { parentInstanceSn } = props
  const params = {
    parentInstanceSn
  }
  const result = await getServiceTipList(params)
  Object.assign(serviceTipData, {
    ...result
  })
}
// 跳转问卷结果
const handleQuestionJump = questionItem => {
  // handleQuestionResults(questionItem);
}
const goAppPage = url => {
  // handleOpenAppPage(url);
}
// 监听内容滚动
const updateShadow = () => {
  if (!scrollWrapperRef.value) return
  const bottomDistance =
    scrollWrapperRef.value.scrollHeight -
    scrollWrapperRef.value.scrollTop -
    scrollWrapperRef.value.clientHeight
  showShadow.value = bottomDistance < 10 ? false : true
}
// 初始化数据
onMounted(async () => {
  // 获取服务患者信息
  await fetchPatientInfo()
  // 获取服务事项列表
  await fetchServiceTipList()
  nextTick(() => {
    updateShadow()
  })
})
</script>

<style scoped lang="scss">
.serviceDetailWrapper {
  width: 100%;
  height: 100%;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  .header {
    margin-bottom: 16px;
    height: 64px;
  }
  .scrollWrapper {
    flex: 1;
    overflow: scroll;
    position: relative;
    .timeline-shadow {
      position: sticky;
      bottom: 0;
      width: 100%;
      height: 8px;
      pointer-events: none;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.05), transparent);
    }
    .serviceTips {
      padding: 0 24px;
      margin-bottom: 6px;
    }

    .serviceProgress {
      // flex: 1;
      min-height: 0;
      padding: 0 24px;
    }
  }

  .footerWrapper {
    margin-top: 12px;
  }
}
</style>
